<template>
  <v-container class="py-0 px-6">
    <v-row class="pl-0 py-0 pr-2">
      <v-col class="py-0" cols="6">
         <h1>Dados do pagamento <br>{{ dataPagamento | formatData}}</h1>
      </v-col>
      <v-col class="text-right" style="display: grid;" cols="6">
        <b style="font-weight: 400" v-if="dataAlteracao">Atualizado: <span style="font-weight: 700">{{ dataAlteracao | formatDateHour}}</span></b>
        <b style="font-weight: 400" v-if="dataIdentificacao">Primeira publicação: <span style="font-weight: 700">{{ dataIdentificacao | formatDateHour}}</span></b>
      </v-col>
      <v-spacer/>
      <v-col cols="12" class="d-flex justify-end">
        <v-tooltip v-if="Boolean(docIdResultado)" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="mr-2 mt-2"
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="getDocument({doc_id: docIdResultado, nome: 'Resultados'})"
            >
              <v-icon medium>fa-file-invoice</v-icon>
            </v-btn>
          </template>
          <span
            class="px-3 py-1 ma-0"
            style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
          >
            Resultados
          </span>
        </v-tooltip>
        <v-tooltip v-if="Boolean(docIdDac)" bottom >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="mr-3 mt-2"
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="getDocument({doc_id: docIdDac, nome: 'Análise de Contas'})"
            >
              <v-icon medium>fa-file-archive</v-icon>
            </v-btn>
          </template>
          <span
            class="px-3 py-1 ma-0"
            style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
          >
            DAC - Demonstrativo de Análise de Contas
          </span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="px-0 py-0">
      <v-col class="py-0" cols="12">
        <v-container class="px-0 py-0">
          <v-row class="ma-0 pa-3 mb-5" style="background-color:#d1dcea">
            <v-col cols="2" class="pa-0 ma-0">
              <div class="px-0 pt-2">
                <b>{{nomeOperadora}}</b>
                <br>
                {{nomePrestador}}
              </div>
            </v-col>
            <v-col cols="10" class="pa-0">
              <v-row class="ma-0">
                <v-col class="text-list text-right px-0 py-1">
                  <small>Vl. informado (R$):</small>
                  <br>
                  <b>{{valorInformado | formatPrice }}</b>
                </v-col>
                <v-col class="text-list text-right px-0 py-1">
                  <small>Vl. lib. de produção (R$):</small>
                  <br>
                  <b style="color:green">{{valorPagoProducao | formatPrice }}</b>
                </v-col>
                <v-col class="text-list text-right px-0 py-1">
                  <small>Glosa Inicial (R$):</small>
                  <br>
                  <b><span style="color:red">{{valorGlosaProducao | formatPrice }}</span></b>
                </v-col>
                <v-col class="text-list text-right px-0 py-1">
                  <small>Vl. lib. de recurso (R$):</small>
                  <br>
                  <b style="color:green">{{valorPagoRecurso | formatPrice }}</b>
                </v-col>
                <v-col class="text-list text-right px-0 py-1">
                  <small>Glosa mantida (R$):</small>
                  <br>
                  <span style="color:red">{{valorGlosaMantida | formatPrice }}</span>
                </v-col>
                <v-col class="text-list text-right px-0 py-1">
                  <small>Glosa recursada (R$):</small>
                  <br>
                  <span style="color:green">{{valorRecursado | formatPrice }}</span>
                </v-col>
                <v-col class="text-list text-right px-0 py-1">
                  <small>Glosa acatada (R$):</small>
                  <br>
                  <span style="color:red">{{valorAcatado | formatPrice }}</span>
                </v-col>
              </v-row>
            </v-col>
           </v-row>
           <v-row class="px-0 py-0">
             <v-col cols="12" class="px-1 py-0">
               <ResumoTable tableName="conciliados" title="Valores conciliados" :valores="valoresConciliados" :pagamentoPublicado="false"/>
               <p class="text-right my-n3 pr-3"><small>Valores em Reais (R$)</small></p>
             </v-col>
             <v-col cols="12" class="px-1 py-0">
               <ResumoTable tableName="estratificados" title="Valores estratificados"  :valores="valoresEstratificados" :pagamentoPublicado="false"/>
               <p class="text-right mt-n3 pr-3"><small>Valores em Reais (R$)</small></p>
             </v-col>
           </v-row>
         </v-container>
      </v-col>
    </v-row>
    <v-tabs v-if="codigoFrontend" v-model="tab" class="elevation-0">
      <v-tab href="#tab-lotes">Lotes Conciliados</v-tab>
      <v-tab href="#tab-glosas" @click="getGlosas">Resumo das glosas</v-tab>
      <v-tab href="#tab-historico" @click="getHistoricoEventos">Histórico de eventos</v-tab>
      <v-tab-item value="tab-glosas" class="pa-5 pt-0">
        <ResumoGlosas
          :dados_pgto="dadosPagamento"
          :list="motivosGlosaList"
        />
      </v-tab-item>
      <v-tab-item value="tab-historico" class="px-2 pt-9 pb-5">
        <HistoricoPagamento :historicoList="historicoList" />
      </v-tab-item>
      <v-tab-item value="tab-lotes" class="pa-1 pt-9">
        <lotes-conciliados-table :valores="lotesConciliados"/>
        <v-pagination
          class="no-box-shadow"
          v-if="hasPagamentoLotesConciliadoPagination"
          v-model="pagamentoLotesConciliadosPage"
          :length="pagamentoLoteConciliadoPageLength"
          :total-visible="7"
        />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { conciliacaoClient } from '../../libs/conciliacao-client'
import { mapState, mapActions } from "vuex"
import moment from 'moment'
import ResumoTable from '@/components/recebiveis/resumo_pagamento/ResumoTable'
import HistoricoPagamento from '@/components/recebiveis/resumo_pagamento/HistoricoPagamento'
import LotesConciliadosTable from '@/components/recebiveis/resumo_pagamento/LotesConciliadosTable'
import ResumoGlosas from '@/components/recebiveis/resumo_pagamento/ResumoGlosas'

export default {
  components: {
    ResumoTable,
    HistoricoPagamento,
    LotesConciliadosTable,
    ResumoGlosas
  },
  data () {
    return {
      tab: null,
      dadosPagamento: {},
      motivosGlosaList: [],
      historicoList: [],
      pagamentoLotesConciliadosPageSize: 10,
      pagamentoLotesConciliadosPage: 1
    }
  },
  props: {
    pagamentoId: { type: String, required: true }
  },
  filters:{
    formatData(val){
      if (val === null) return '-'
      return  moment(val).format('DD/MM/YYYY')
    },
    formatDateHour(date) {
      return moment(date).format('L') + ' às ' + moment(date).format('LT') + 'h'
    }
  },
  computed:{
    ...mapState({
      grupoEconomico: state => state.permissions.grupoEconomico,
      userData: (state) => state.userData.userData,
    }),
    valoresConciliados () {
      const pagamento = this.getPagamentoById
      return {
        valorInformado: pagamento?.valorInformadoConciliado,
        valorLiberado: pagamento?.valorPagoConciliado,
        valorGlosado: pagamento?.valorGlosadoConciliado,
        valorRecursado: pagamento?.valorPagoRecursoConciliado + pagamento?.valorGlosaMantidaConciliado,
        valorAcatado: pagamento?.valorGlosadoConciliado - pagamento?.valorPagoRecursoConciliado - pagamento?.valorGlosaMantidaConciliado,
        percent: pagamento?.valorInformado ? pagamento?.valorInformadoConciliado/pagamento?.valorInformado : 0
      }
    },
    valoresEstratificados () {
      const pagamento = this.getPagamentoById

      return {
        valorInformado: this.valorInformado - this.valoresConciliados.valorInformado,
        valorLiberado: pagamento?.valorPago - this.valoresConciliados.valorLiberado,
        valorGlosado: pagamento?.valorGlosado - this.valoresConciliados.valorGlosado,
        valorRecursado: pagamento?.valorRecursado - this.valoresConciliados.valorRecursado,
        valorAcatado: pagamento?.valorAcatado - this.valoresConciliados.valorAcatado,
        percent: this.valorInformado ? (this.valorInformado - this.valoresConciliados.valorInformado)/this.valorInformado : 0
      }
    },
    dataPagamento () {
      return this.getPagamentoById?.dataPagamento || null
    },
    dataAlteracao () {
      return this.getPagamentoById?.dataAlteracao || null
    },
    dataIdentificacao () {
      return this.getPagamentoById?.dataIdentificacao || null
    },
    docIdResultado () {
      return this.getPagamentoById?.docIdPlanilhaResultado || null
    },
    docIdDac () {
      return this.getPagamentoById?.docIdDac || null
    },
    nomeOperadora () {
      return this.getPagamentoById?.operadoraAns?.nome || '-'
    },
    nomePrestador () {
      return this.getPagamentoById?.prestador?.nome || '-'
    },
    valorInformado () {
      return this.getPagamentoById?.valorInformado
    },
    valorPagoProducao () {
      return this.getPagamentoById?.valorPagoProducao
    },
    valorGlosaProducao () {
      return this.getPagamentoById?.valorGlosaProducao
    },
    valorPagoRecurso () {
      return this.getPagamentoById?.valorPagoRecurso
    },
    valorGlosaMantida () {
      return this.getPagamentoById?.valorGlosaMantida
    },
    valorRecursado () {
      return this.getPagamentoById?.valorRecursado
    },
    valorAcatado () {
      return this.getPagamentoById?.valorAcatado
    },
    codigoFrontend () {
      return this.getPagamentoById?.codigoFrontend ? Number(this.getPagamentoById?.codigoFrontend) : null
    },
    lotesConciliados () {
      return this.getPagamentoLotesConciliadosPage?.data || []
    },
    hasPagamentoLotesConciliadoPagination () {
      return this.getPagamentoLotesConciliadosPage?.totalSize / this.pagamentoLotesConciliadosPageSize > 1
    },
    pagamentoLoteConciliadoPageLength () {
      return Math.ceil(this.getPagamentoLotesConciliadosPage?.totalSize / this.pagamentoLotesConciliadosPageSize) || 0
    },
    payload () {
      var payload = {
        grupo_economico: this.grupoEconomico,
        id: this.codigoFrontend,
        pagamento_id: this.codigoFrontend
      }

      return payload
    }
  },
  asyncComputed: {
    getPagamentoById: {
      get () {
        const params = {
          includePrestador: true,
          includeOperadoraAns: true
        }

        return conciliacaoClient.pagamento.getPagamentoById(this.pagamentoId, params)
      }
    },
    getPagamentoLotesConciliadosPage: {
      get () {
        const params = {
          pagamentoId: this.pagamentoId,
          isConciliado: true,
          pageNumber: this.pagamentoLotesConciliadosPage - 1,
          pageSize: this.pagamentoLotesConciliadosPageSize
        }

        return conciliacaoClient.pagamentoLote.getPagamentoLotesPage(params)
      }
    }
  },
  methods: {
    ...mapActions({
      'getDocument':'documents/getDocument'
    }),
    getDetalhesPagamento() {
      let obj = { query:[{modulo: 'Recebiveis', acao: 'getdetalhespagamentopublicado', payload: this.payload}] }
      this.$store.dispatch("request/doRequest",obj).then(response => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return false
        }
        this.dadosPagamento = response.dados
      })
    },
    getResumoMotivosGlosa() {
      let obj = { query:[{modulo: 'Recebiveis', acao: 'getmotivosglosa', payload: this.payload}] }
      this.$store.dispatch("request/doRequest",obj).then(response => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return false
        }
        this.motivosGlosaList = response.dados
      })
    },
    getHistoricoEventos() {
      let obj = {query:[{Modulo: "Recebiveis", Acao: "gethistoricopagamentospublicados", Payload: this.payload}]}
      this.$store.dispatch("request/doRequest", obj).then((response) => {
          if (!response || response.isAxiosError || !response.sucesso) {
              this.$store.commit("hideLoader")
              return
          }
      this.historicoList = response.dados
      })
    },
    getGlosas () {
      this.getDetalhesPagamento()
      this.getResumoMotivosGlosa()
    }
  }
}
</script>
